import React, { useEffect } from "react"
import { Routes, Route } from "react-router-dom"
import { useStateContext } from "../components/contexts/ContextProvider"

import { Navbar, Footer, Sidebar, ThemeSettings } from "../components/UI"

import {
  Dashboard,
  Calendar,
  Employees,
  Customers,
  Line,
  Area,
  Bar,
  Pie,
  Financial,
  ColorMapping,
  Pyramid,
  Stacked,
} from "../components/pages"

import Discount from "../components/pages/Discount"
import Marketing from "../components/pages/Marketing"
import Booking from "../components/pages/Booking"
import Workflow from "../components/pages/Workflow"
import Services from "../components/pages/Services"
import Offers from "../components/pages/Offers"
import Media from "../components/pages/Media"

import "./Style.css"
import ManagerScheduler from "../components/pages/Calendar/ManagerCalendar"

const RouteIndex = () => {
  const userStr = localStorage.getItem("user")
  const userData = userStr ? JSON.parse(userStr) : null
  const { role = "", empId = "" } = userData?.profile ?? {}

  const {
    setCurrentColor,
    setCurrentMode,
    currentMode,
    activeMenu,
    themeSettings,
  } = useStateContext()

  useEffect(() => {
    const color = localStorage.getItem("colorMode")
    const mode = localStorage.getItem("themeMode")
    if (color && mode) {
      setCurrentColor(color)
      setCurrentMode(mode)
    }
  }, [])

  return (
    <div className={currentMode === "Dark" ? "dark" : ""}>
      <div className="flex relative dark:bg-main-dark-bg">
        {activeMenu && (
          <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white">
            <Sidebar />
          </div>
        )}

        <div
          className={
            activeMenu
              ? "bg-main-bg dark:bg-main-dark-bg min-h-screen md:ml-72 w-full"
              : "bg-main-bg dark:bg-main-dark-bg w-full min-h-screen"
          }
        >
          <Navbar />

          {themeSettings && <ThemeSettings />}

          <Routes>
            {/* COMMON */}
            <Route path="/overview" element={<Dashboard />} />
            <Route path="/bookings" element={<Booking />} />

            {role === "manager" && empId === "2026_BOOST_5895" ? (
              <Route path="/calendar" element={<Calendar />} />
            ) : (
              <Route path="/calendar" element={<ManagerScheduler />} />
            )}

            {/* ADMIN ONLY */}
            {role === "admin" && (
              <>
                <Route path="/customers" element={<Customers />} />
                <Route path="/employees" element={<Employees />} />
                <Route path="/marketing" element={<Marketing />} />
                <Route path="/services" element={<Services />} />
                <Route path="/workflow" element={<Workflow />} />
                <Route path="/discount" element={<Discount />} />
                <Route path="/offers" element={<Offers />} />
                <Route path="/media" element={<Media />} />

                <Route path="/line" element={<Line />} />
                <Route path="/area" element={<Area />} />
                <Route path="/bar" element={<Bar />} />
                <Route path="/pie" element={<Pie />} />
                <Route path="/financial" element={<Financial />} />
                <Route path="/color-mapping" element={<ColorMapping />} />
                <Route path="/pyramid" element={<Pyramid />} />
                <Route path="/stacked" element={<Stacked />} />
              </>
            )}
          </Routes>

          <Footer />
        </div>
      </div>
    </div>
  )
}

export default RouteIndex
